import type { FC } from 'react';

import { Alert, Button, Dialog, Sheet, Space, Typography } from '@sravni/react-design-system';
import { useIsMobile } from '@sravni/react-utils';

import styles from './ServiceBannerInfoSheet.module.scss';
import { ServiceBannerInfoSheetTexts } from './ServiceBannerInfoSheet.texts';

type ServiceBannerInfoSheetProps = { visible: boolean; onClose: () => void; onButtonClick: () => void };

export const ServiceBannerInfoSheetSheet: FC<ServiceBannerInfoSheetProps> = ({ visible, onClose, onButtonClick }) => {
  const isMobile = useIsMobile();

  const Variant = isMobile ? Sheet : Dialog;

  return (
    <Variant visible={visible} onClose={onClose} className={styles.container}>
      <Variant.Header>
        <Typography.Text size={20} className={styles.header} strong>
          {ServiceBannerInfoSheetTexts.title}
        </Typography.Text>
      </Variant.Header>
      <Variant.Content>
        <Space direction="vertical" size={8}>
          <Typography.Text className={styles.content}>{ServiceBannerInfoSheetTexts.content}</Typography.Text>
          <br />
          <Typography.Text className={styles.content}>{ServiceBannerInfoSheetTexts.description}</Typography.Text>
        </Space>
      </Variant.Content>
      <Variant.Footer>
        <Button onClick={onButtonClick} variant="primary" block size={52}>
          {ServiceBannerInfoSheetTexts.buttonText}
        </Button>
      </Variant.Footer>
    </Variant>
  );
};
